import { api } from "@/lib/api";
import { createAppointmentChecklist } from "@/lib/appointment-checklist";

export const AppointmentChecklistRepository = createAppointmentChecklist(api.appointments);
